import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import URI from "URI/URI";
import markup from "ulysses/widgets/action_button/action.html";

"use strict";
$(document).ready(function() { $(markup).appendTo($("body")); });

var configure_action = function configure_action(current_data) {
    var res = Promise.Deferred();
    var cdata = ko.toJS(current_data) || {};
    cdata = $.extend({"action":null, "caption":null, "icon":null, "colour": null},cdata);

    var dialog = uly.dialogs.execute($("#action-button-editor-tmpl").html(), {
        "title": _("actionbutton_title_edit_action", "Configure Action Button")
    }, cdata).then(function([result]) {
        res.resolve({
            "action": ko.unwrap(result.action),
            "icon": ko.unwrap(result.icon),
            "caption": ko.unwrap(result.caption),
            "colour": ko.unwrap(result.colour)
        });
    }).fail(res.reject);
    return res.promise();
};

function build_indicator_model(settings_obs) {
    var model = {};
    $.extend(model, {
        "icon":ko.observable(ko.unwrap(settings_obs).icon || "fa-dashboard"),
        "colour":ko.observable(ko.unwrap(settings_obs).colour || "default"),
        "value":ko.observable(null),
        "caption":ko.observable(ko.unwrap(settings_obs).caption),
        "details_url":ko.observable(null),
        "hardcoded_model": ko.observable(null),
        "local_params": ko.observable(null),
        "indicator": ko.pureComputed(function() { return ko.unwrap(settings_obs).indicator; }),
        "search_settings": ko.observable({}),
        "path": ko.unwrap(settings_obs).path,
        "extra_filter": ko.unwrap(settings_obs).extra_filter,
        "extra_solr_filter": ko.unwrap(settings_obs).extra_solr_filter
    });
    return model;
}
ko.bindingHandlers.actionbutton = {
    "init":function(elt, va, allbindings, model, context) {
        console.log("actionbutton:", va(), ko.unwrap(va()));
        var data = ko.unwrap(va());
        var child = context.createChildContext(data);
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    }
};

uly.widgets.register({
    "type":"actionbutton",
    "caption":_("widget_actionbutton_caption_actionbutton", "Action Button"),
    "description":_("widget_actionbutton_description", "A button triggering an action"),
    "icon":"fa-button",
    "hidden": true,
    "init":function() {
        var data = { 
            "action":ko.observable(null), 
            "icon":ko.observable(null), 
            "colour":ko.observable(null), 
            "caption":ko.observable(null) 
        };
        var init_def = Promise.Deferred();
        configure_action(data).then(function(result) {
            result = ko.toJS(result);
            init_def.resolve(result);
        }).fail(init_def.reject);
        return init_def;
    },
    "colour":"primary"
});


// uly.actions.pickindicator = function(e, $elt, ui) {
//     var selected_indicator = ko.unwrap(ui.model.name);
//     ui.context.$parent.indicator(selected_indicator);
//     e.stopPropagation();
//     return false;
// };

// uly.actions.changeindicator = function(e,$elt,ui) {
//     modify_indicator(ui.context.$parent);
//     e.stopPropagation();
//     return false;
// };

export default {
    configure_action:configure_action
};
